import * as WebMaps from '@teovilla/react-native-web-maps'
import { useEffect, useMemo } from 'react'
import { StyleSheet, View } from 'react-native'
import type { MapViewProps } from 'react-native-maps'
import { ActivityIndicator } from 'react-native-paper'
import { GOOGLE_MAPS_API_KEY } from '@/lib/config'

export * from '@teovilla/react-native-web-maps'

const MAP_CSS = `
.gm-style-iw-chr { height: auto !important; padding: 0 !important; }
.gm-style-iw.gm-style-iw-c { display: flex; flex-direction: row-reverse; }
.gm-style-iw-ch { display: none; }
.gm-style-iw-d { overflow: hidden !important; margin: 5px; }
`

function useMapStyles() {
    useEffect(() => {
        const style = document.createElement('style')
        style.textContent = MAP_CSS
        document.head.appendChild(style)
        return () => {
            style.remove()
        }
    }, [])
}

const MapView = (props: MapViewProps) => {
    useMapStyles()
    const WebMapModule = WebMaps as unknown as {
        default?: React.ComponentType<MapViewProps>
        MapView?: React.ComponentType<MapViewProps>
    }
    const WebMapView =
        WebMapModule.default ||
        WebMapModule.MapView ||
        (WebMaps as unknown as React.ComponentType<MapViewProps>)

    const loadingFallback = useMemo(
        () => (
            <View style={[styles.loadingContainer, props.style]}>
                <ActivityIndicator size="large" />
            </View>
        ),
        [props.style]
    )

    const mapProps = {
        loadingFallback,
        ...props,
        provider: 'google',
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    } as unknown as MapViewProps
    return <WebMapView {...mapProps} />
}

const styles = StyleSheet.create({
    loadingContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
})

export default MapView
